import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Loading } from '@/components/loading';
import { AccessKeyDetail } from '@/components/access-key-detail';
import {
  useListServiceAccountsQuery,
  accountsSelector,
  useUpdateServiceAccountAccessKeyMutation,
} from '@/api/organisation';
import { useNow } from '@/hooks/use-now';

const SettingsOrganisationServiceAccountKeyDetail = () => {
  const { organisationId, accountId, keyId } = useParams<{
    organisationId: string;
    accountId: string;
    keyId: string;
  }>();
  const navigate = useNavigate();
  const now = useNow();
  const orgId = Number(organisationId);
  const accId = Number(accountId);

  const { isLoading } = useListServiceAccountsQuery(orgId);
  const accounts = useSelector(accountsSelector(orgId));
  const account = accounts.find((a) => a.id === accId);
  const accessKey = account?.keys.find((k) => k.id === keyId);

  const [updateKey, { isLoading: isUpdating }] =
    useUpdateServiceAccountAccessKeyMutation();

  const onUpdate = useCallback(
    async (scopes: string[], expiresAt?: string | null) => {
      if (keyId) {
        await updateKey({
          organisationId: orgId,
          accountId: accId,
          keyId,
          scopes,
          expiresAt,
        }).unwrap();
      }
    },
    [orgId, accId, keyId, updateKey],
  );

  const onBack = useCallback(() => {
    navigate(`/settings/organisation/${organisationId}/service-accounts`);
  }, [navigate, organisationId]);

  if (isLoading) {
    return <Loading />;
  }

  if (!accessKey) {
    return <Loading />;
  }

  return (
    <AccessKeyDetail
      accessKey={accessKey}
      now={now}
      onUpdate={onUpdate}
      onBack={onBack}
      isUpdating={isUpdating}
    />
  );
};

export { SettingsOrganisationServiceAccountKeyDetail };
